import { Pipe, PipeTransform } from '@angular/core';
import * as countries from 'i18n-iso-countries';

@Pipe({
    name: 'countryTranslation'
})
export class CountryTranslation implements PipeTransform {
    transform(countryCode: string, language: string): string {
        let value: string = null;
        if (language && countryCode){
            value = countries.getName(countryCode, language);
        }
        return value;
    }
}

